export enum SourceDataInitials {
    None = '',
    FieldData = 'fd',
    SubjectProperty = 'sp',
    TransferData = 'td',
    CascadeData = 'cd',
    Database = 'db',
    Mls = 'mls',
    PublicRecords = 'pr',
    SmartExchange = 'se',
    CustomValue = 'cv',
    UserOverride = 'ut',
    FormFiller = 'ff'
}
